import React, { useState, useEffect } from 'react';
import '../../../scss/components/pages/staffList.scss';
import swal from 'sweetalert2';
import '../../../scss/components/pages/home.scss';
import API from '../../../middleware/API';
import moment from 'moment';
import axios from 'axios';
import { lowerCase } from 'lodash';
import Slider from 'react-slick';
import Pagination from '../../Pagination';
import {useDispatch} from 'react-redux';
import ReviewOvertime from '../../ReviewOvertime'
import {years,GetStoreRole,GetStoreDetailRole, CalculateNormalHourMultipiler, CalculateHolidayHourMultipiler} from '../../../const/constant';

const SigningOvertimeRec = () => {
  const [leaveRecList, setLeaveRecList] = useState ([]);
  const [recordList, setRecordList] = useState ([]);
  const [leaveTypeList, setLeaveTypeList] = useState ([]);
  const [checkedLeaveRecList, setcheckedLeaveRecList] = useState ([]);
  const [isEditShow, setIsEditShow] = useState (false);
  const [status, setStatus] = useState ('S');
  const [editTarget, setEditTarget] = useState ({});
  const [keyword, setKeyword] = useState ('');
  const [reload, doReload] = useState (false);
  const [currPage, setCurrPage] = useState (1);
  const [year, setYear] = useState(moment().year());
  const [totalPage, setTotalPage] = useState (0);
  const [countOfPage, setCountOfPage] = useState (5);
  const [switchPanel, setSwitchPanel] = useState (1);
  const dispatch = useDispatch()
  const monthList = [1,2,3,4,5,6,7,8,9,10,11,12]
  const [ip, setIP] = useState('');
  const role =  GetStoreRole(localStorage.getItem('current_store_id'))  ;
  const detailrole =  GetStoreDetailRole(localStorage.getItem('current_store_id'))  ;

  useEffect(
    ()=>{
      var url = 'Overtime/Pending/'+status+ '?page=' + (currPage - 1) +'&count='+countOfPage;

      if(keyword.length > 0)
        url = url + '&keyword=' + keyword;
      axios.all([
        API.get(url),
        API.get('OverTime/Statistic/'+year),
      ]).then(
        axios.spread((res,recordRes) => {
          setLeaveRecList(res.pendingList)
          setTotalPage(Math.ceil(res.totalCount / 5))
          setcheckedLeaveRecList(res.pendingList)
          setRecordList(recordRes)
        })
      );    
    }
  ,[reload]);

  useEffect(
    ()=>{
      var url = 'Overtime/Pending/'+status+ '?page=' + (currPage - 1)+'&count='+countOfPage;

      if(keyword.length > 0)
        url = url + '&keyword=' + keyword;
      axios.all([
        API.get(url),
      ]).then(
        axios.spread((res) => {
          setLeaveRecList(res.pendingList)
          setTotalPage(Math.ceil(res.totalCount / 5))
          setcheckedLeaveRecList(res.pendingList)
        })
      );    
    }
  ,[keyword, status]);
  const updateSingleRec = (leaveRec) => {
    const overTimeHours = parseFloat(leaveRec.overTimeHours) || 0;
    const pay = parseFloat(leaveRec.pay) || 0;
    const payStandard = pay > 2000 ? pay / 240 : pay;
    const holidayPay = (payStandard * CalculateHolidayHourMultipiler(overTimeHours)).toFixed(0);
    const normalPay = (payStandard * CalculateNormalHourMultipiler(overTimeHours)).toFixed(0);
    const doublePay = (payStandard * overTimeHours * 2).toFixed(0);
    const currentPayType = String(leaveRec.payType);
    const editablePayTypeOptions = [
      ['1', `轉換補休時數：${overTimeHours} 小時`],
      ['3', `休假日加班費：${holidayPay}元`],
      ['2', `加班費：${normalPay}元`],
      ['4', `國定假日：${doublePay}元`],
      ['5', `例假日加班：${doublePay}元 + ${overTimeHours} 小時`],
    ].filter(([value]) => value !== currentPayType);

    if (editablePayTypeOptions.length === 0) {
      swal({
        type: 'info',
        title: '沒有可變更的方式',
        heightAuto: false
      });
      return;
    }

    swal({
        type: 'info',
        title: '請選擇要改成的方式',
        input: 'select',
        inputOptions: new Map(editablePayTypeOptions),
        inputValue: editablePayTypeOptions[0][0],
        showConfirmButton: true,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        if(!result.dismiss && result.value)  {
            let data = {
                id: leaveRec.id,
                payType: parseInt(result.value)
            }
        
            API.put('OverTime', data).then((res) => {
              swal({
                type: 'success',
                title: '修改成功',
                heightAuto: false
              })
                if (res) {
                  doReload(!reload);    
                }
              });             
        }
      })
};
  const signingSingleRec = (id, status) => {
    swal({
        type: 'info',
        input: 'text',
        title: '輸入備註(選填)',
        showConfirmButton: true,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        if(!result.dismiss)  {
            let data = {
                overTimeIds: id,
                status: status,
                note: result.value,
                leaveHours: 0
            }
        
            API.put('OverTime/Signing', data).then((res) => {
                if (res) {
                  doReload(!reload);    
                }
              });             
        }
      })
};
  const signingMultiRec = (status) => {
        //後端會根據是否為兼職強制修改payType

    swal({
      type: 'info',
      input: 'text',
      title: '輸入備註(選填)',
      showConfirmButton: true,
      showCloseButton: true,
      heightAuto: false
    }).then((result) => {
      if(!result.dismiss)  {
        var signingIds = '';
        checkedLeaveRecList.forEach((checkedLeaveRec) => {
          if (checkedLeaveRec.isChecked){
            signingIds = signingIds + checkedLeaveRec.id  + ','
          }        
        });
        let data = {
            overTimeIds: signingIds.slice(0, -1),
          status: '1',
          note:result.value,
          leaveHours: 0,
        }
      
        API.put('OverTime/Signing', data).then((res) => {
          if (res) {
          doReload(!reload);    
          }
        }); 
      }
    })
  };
  const onChangeStep = (step)=> {
    if (switchPanel === step) return;
    setSwitchPanel(step);
  }
  const onChangeYearFunc = (e) => {
    setYear(e.target.value);
    doReload(!reload);
  }
  const signingRecNew = (id, status, comment, payType) => {
    //後端會根據是否為兼職強制修改payType
    let data = {
      overTimeIds: id,
      status: status,
      note: comment,
      payType: payType,
    }
    API.put('OverTime/Signing', data).then((res) => {
      if (res) {
        setIsEditShow(false);
        doReload(!reload);    
      }
    });             
  };
  const updateLeaveHours = (key,e)=>{
    setEditTarget({...editTarget,leaveHours:e.target.value});
  }

  const handleChangePage = (page) => {
    setCurrPage(page);
    doReload(!reload);
  }

  const diff = (start, end) => {
    var startMoment = moment(start);
    var endMoment = moment(end);
    
    return (endMoment - startMoment) / 1000 / 60 / 60; 
  }
  const handleCheckChieldElement = (event) => {
    let fruites = checkedLeaveRecList;
    fruites.forEach((leaveRec) => {       
      if (leaveRec.id === parseInt(event.target.value))
      {
          leaveRec.isChecked =  event.target.checked
      }
    })
    setcheckedLeaveRecList(fruites);
  }

  const settings = {
    dots: true,
    arrows: false,
  };

  const slides = leaveRecList.map((leaveRec, index) => (
    <div key={leaveRec.id}>
    <table className="u-table u-table-border u-table-striped u-table-media-phone">
      <tbody>
        <tr>
          <th>加班單ID</th>
          <td>{leaveRec.id}</td>
        </tr>
        <tr>
          <th>姓名</th>
          <td>{leaveRec.applyUser}</td>
        </tr>
        <tr>
        <th>申請加班日</th>
        <td>{moment(leaveRec.applyDate).format('YYYY-MM-DD')} 
        </td>
        </tr>
        <tr>
        <th>預期時間</th>
        <td>{moment(leaveRec.expectSignInTime).format('HH:mm')}~
        {moment(leaveRec.expectSignOutTime).format('HH:mm')}</td>
        </tr>
        <tr>
        <th>打卡時間</th>
        <td>
        { 
          leaveRec.records.data.length > 0 ?
            leaveRec.records.data.map(actualEvent=>
              <React.Fragment key={actualEvent.id}>
                <span>{actualEvent.actualSignInTime} ~ {actualEvent.actualSignOutTime}</span><br/>
              </React.Fragment>)
              :''
        }
        </td>
        </tr>
        <tr>
        <th>加班時間</th>
        <td>{moment(leaveRec.startAt).format('HH:mm')} ~ {moment(leaveRec.endAt).format('HH:mm')}</td>
        </tr>
        <tr>
        <th>加班時數</th>
        <td>{leaveRec.overTimeHours}</td>
        </tr>{
status === '1'?
<tr>
<th>方式</th>
<td>{leaveRec.payType === 1?'補休':leaveRec.payType === 2?'加班費':leaveRec.payType === 3?'休假日加班費':leaveRec.payType === 5?'例假日加班':'國定假日'}</td>
</tr>
:<React.Fragment></React.Fragment>
        }
        <tr>
        <th>事由</th>
        <td style={{whiteSpace:'break-spaces'}}>{leaveRec.reason ? leaveRec.reason : '未填寫'}</td>
        </tr>
        <tr>
        <th>簽核</th>
        {
          status !== 'X'? status === 'S'?
          <td>{
            leaveRec.fileName?<>
            <button onClick={() => {window.open(leaveRec.fileName, "_blank")}}>附件</button> <br/>
            </>:''
          }
          <button className="btn btn-md save" onClick={() => {
                console.log(leaveRec);
                setIsEditShow(true)
                setEditTarget(leaveRec)
                }}>簽核</button>
          </td>:<td>
          {
            status == '1' && (leaveRec.payType == 1 || leaveRec.payType == 2)?<button className="btn btn-md warning" onClick={() => updateSingleRec(leaveRec)}>編輯</button>:''
          }
            <button className="btn btn-md delete" onClick={() => signingSingleRec(leaveRec.id, 'X')}>作廢</button></td>:<td style={{display:'none'}}>
              
            </td>  

        }

        </tr>
        
      </tbody>
    </table>
  </div>
  ))
 return(
  <div className="p-signTime">
  <div className="u-tag_group">
    <a className={switchPanel === 1 ? 'tag active' : 'tag'} onClick={() => { onChangeStep(1); }} >簽核加班單</a>
    <a className={switchPanel === 2 ? 'tag active' : 'tag'} onClick={() => { onChangeStep(2); }} >加班紀錄</a>
  </div>
  <div className="u-block u-block--fixHeight">

  <div id="signing-block" style={{ display: switchPanel === 1 ? 'block' : 'none'}} className="m-t-16">

      <div className="u-title">待簽核加班單列表 {ip}
        <a
              href="https://docs.google.com/presentation/d/1LymJWB_-odjUthdb-PprWznaOKYDabYoLK2JxJhAVrQ/edit?usp=sharing"
              className="u-how-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fa-question-circle" />
          </a>
      </div>

      <div className="u-search-box">
      <div className="u-btn-group p-0  u-table-media" style={{justifyContent: 'end'}}>
      {
        // status === 'S'?
        // <>
        //   <button className="btn btn-md success" onClick={() => signingMultiRec('1')}>選取核准</button>
        // </>
        // :
        // ''
      }

      </div>
          <div className="u-search-box_right">
          <div className="date-input">
          <input className="u-form__input" value={keyword} placeholder="請輸入姓名" onChange={(e)=>{setKeyword(e.target.value);setCurrPage(1);}} />
          <span className="mobile-hide"style={{ flex: '0 0 0px' }}>狀態：</span>

            <select style={{minWidth:"56px"}} value={status} onChange={(e)=>{setStatus(e.target.value); setCurrPage(1)}} className="u-form__select">
            <option value="S">送簽</option>
            <option value="1">核准</option>
            <option value="X">作廢</option>
            </select>
          </div>
          </div>
          
        </div>

      <div className="u-table-responsive">    
      <table className="u-table u-table-border u-table-striped u-table-media">
          <thead>
            <tr>
                {
                //   status === 'S'? 
                //   <th style={{width:'30px'}}></th>
                //   :<th style={{display:'none'}}></th>
                }
                <th>加班單ID</th>
                <th>姓名</th>
                <th>申請加班日</th>
                <th>預期時間</th>

                <th>打卡時間</th>
                <th>總時數</th>
                <th>加班時間</th>
                <th>加班時數</th>
                {
                  status === '1'? 
                  <th style={{width:'30px'}}>方式</th>                  
                  :<th style={{display:'none'}}></th>
                }
                {
                  status === '1'? 
                  <th style={{width:'30px'}}>簽核人</th>:
                  status === 'X'? 
                  <th style={{width:'30px'}}>作廢人</th>
                  :<th style={{display:'none'}}></th>
                }
                {detailrole == '15'?'':
                  status !== 'X'? <th>操作</th> :<th style={{display:'none'}}>操作</th>
                }
                <th>送簽日 / 簽核日</th>

            </tr>
          </thead>
            {
              leaveRecList.filter(m=>m.status === status).map(leaveRec => (
                <tbody key={leaveRec.id}>
                  <tr>
                    <td style={{verticalAlign:'middle'}}>{leaveRec.id}</td>
                    <td style={{verticalAlign:'middle'}}>{leaveRec.applyUser}</td>
                    <td style={{verticalAlign:'middle'}}>{moment(leaveRec.applyDate).format('YYYY-MM-DD')}</td>
                    <td style={{verticalAlign:'middle'}}>
                      {
                        moment(leaveRec.expectSignInTime).format('HH:mm') == '00:00' ? 
                        <span>無預排班</span>:
                        <span>
                          {moment(leaveRec.expectSignInTime).format('HH:mm')} ~
                          {moment(leaveRec.expectSignOutTime).format('HH:mm')}
                        </span>
                      }

                    </td>
                    <td style={{verticalAlign:'middle'}}>{
                      leaveRec.records.data.length > 0 ?
                      leaveRec.records.data.map(actualEvent=>
                        <React.Fragment key={actualEvent.id}>
                          <span>{actualEvent.actualSignInTime} ~ {actualEvent.actualSignOutTime}</span><br/>
                        </React.Fragment>):''

                    }</td>
                    <td style={{verticalAlign:'middle'}}>{leaveRec.records.totalWorkTime.replace(':','時')}分</td>
                    <td style={{verticalAlign:'middle'}}>{moment(leaveRec.startAt).format('HH:mm')} ~ {moment(leaveRec.endAt).format('HH:mm')}</td>
                    <td style={{verticalAlign:'middle'}}>
                      {leaveRec.overTimeHours}
                    </td>
                    {
                      status === '1'? 
                      <td>{leaveRec.payType === 1?'補休':leaveRec.payType === 2?'加班費':leaveRec.payType === 3?'休假日加班費':leaveRec.payType === 5?'例假日加班':'國定假日'}</td>
                      :<td style={{display:'none'}}></td>
                    }
                    {
                      status === '1'? 
                      <td>
                        {
                          leaveRec.modifiedUser ?
                          <>
                            簽核人：{leaveRec.approveUser ? leaveRec.approveUser.realName : ''}<br/>
                            修改人：{leaveRec.modifiedUser ? leaveRec.modifiedUser.realName : leaveRec.modifiedUserName}
                          </> :
                          `簽核人：${leaveRec.approveUser ? leaveRec.approveUser.realName : ''}`
                        }
                      </td>:
                      status === 'X'? 
                      <td>{leaveRec.modifiedUserName}<br/>{moment(leaveRec.modifiedDate).format('YYYY-MM-DD HH:mm:ss')}</td>
                      :<td style={{display:'none'}}></td>
                    }
                    {detailrole == '15'?'':
                      status !== 'X'? status === 'S'?
                      <td>
                      <button className="btn btn-md save" onClick={() => {
                            console.log();
                            setIsEditShow(true)
                            setEditTarget(leaveRec)
                            //signingSingleRec(leaveRec.id, '1');
                            }}>簽核</button>
                      </td>:
                      <td>
                      {
                        leaveRec.fileName?<>
                        <button onClick={()=> {window.open(leaveRec.fileName, "_blank")}}>附件</button> <br/>
                        </>:''
                      }  
                      {
                        status == '1' ?<button className="btn btn-md warning" onClick={() => updateSingleRec(leaveRec)}>編輯</button>:''
                      }
                      
                      <button className="btn btn-md delete" onClick={() => signingSingleRec(leaveRec.id, 'X')}>作廢</button></td>:<td style={{display:'none'}}>
                      </td>  
                    }
                    <td style={{verticalAlign:'middle'}}>{moment(leaveRec.sendDate).format('YYYY-MM-DD')}{moment(leaveRec.approveDate).format('YYYY-MM-DD') !== '0001-01-01'? ' / '+moment(leaveRec.approveDate).format('YYYY-MM-DD'): ' / 尚未簽核'} </td>
                  </tr>
                  <tr>
                      <td colSpan='10' style={{textAlign:'left'}}>事由：{leaveRec.reason ? leaveRec.reason : '未填寫'}</td>
                  </tr>
                  {
                  status === 'S'? 
                  <React.Fragment></React.Fragment>
                  :
                  <tr>
                    <td colSpan='10' style={{textAlign:'left'}}>備註：{leaveRec.notes ? leaveRec.notes : '無備註'}</td>
                  </tr>
                  }
                </tbody>
                ))}
        </table>
      </div>
      {
        leaveRecList.length > 0 ? <Slider {...settings}>
        {
          slides
        }
      </Slider>:''
      }
      <div className="pagination-box">
        <Pagination 
            currPage={currPage} totalPage={totalPage}
            onChangPage={handleChangePage}
        />
      </div>
      <ReviewOvertime 
          isVisible={isEditShow} 
          toggleOpen={()=>{setIsEditShow(!isEditShow);}} 
          editTarget={editTarget}
          signingFunc={signingRecNew}
          onChangeFunc={updateLeaveHours}
        />
    </div>
  
    <div id="record-block" style={{ display: switchPanel === 2 ? 'block' : 'none'}} className="m-t-16">

    <div className="u-title">員工加班紀錄          

    
        <a
              href="https://docs.google.com/presentation/d/1LymJWB_-odjUthdb-PprWznaOKYDabYoLK2JxJhAVrQ/edit?usp=sharing"
              className="u-how-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fa-question-circle" />
          </a></div>
          <div className="sign-notice">
          <div className="u-notice">*溫馨提醒: </div>
          <div className="u-notice">括號內<span style={{color:'green'}}>綠色</span>表示補休加班時數，<span style={{color:'red'}}>紅色</span>表示加班費加班時數。</div>
        </div>
          <div className="u-search-box">
    <div className="date-input">
                
                <select
                  value={year}
                  className="u-form__select"
                  onChange={onChangeYearFunc}
                >
                  {
                    years.map(year => (
                      <option key={year.id} value={year.id}>{year.text}</option>
                    ))
                  }
                </select>
                <span>年</span>
              </div>
            </div>
          <div className="u-table-responsive">    
          </div>

            <table className="u-table u-table-border u-table-striped u-table-media">
            <thead>
              <tr>
                <th>
                  員工\月份
                </th>
                {
                  monthList.map((item, index)=>{
                    return <th key={index}>{item}</th>;
                  })
                }
                <th>
                  小計
                </th>
              </tr>
            </thead>
            <tbody>
              {
                recordList.map((item, index)=>{
                  return <tr key={index}>
                    <td>
                      {item.name}
                    </td>
                    {
                      monthList.map((monthInList, index)=>{
                        return <td key={index}>
                        {
                          item.monthHourList.find(m=>m.month === monthInList)?
                          item.monthHourList.filter(m=>m.month === monthInList)
                          .map(item => item.hours)
                          .reduce((prev, next) => prev + next)
                          :0
                        }<br/>{
                          item.monthHourList.find(m=>m.month === monthInList)?
                          <>(<span style={{color:'green'}}>{item.monthHourList.find(m=>m.month === monthInList).compensatoryHours}</span>+<span style={{color:'red'}}>{item.monthHourList.find(m=>m.month === monthInList).payHours}</span>)</>
                          :''
                        }
                        </td>
                      })
                    }
                    <td>
                      {
                        item.monthHourList
                        .map(item => item.hours)
                        .reduce((prev, next) => prev + next)
                      }
                    </td>
                  </tr>
                })
              }
            </tbody>
            </table>
      </div>
    </div>
    </div>
 );
}

export default SigningOvertimeRec

